import { Injectable } from '@angular/core';
import { CreateHotToastRef, HotToastService } from '@ngneat/hot-toast';
import { Person } from '@prisma/client';
import { of } from 'rxjs';
import { finalize, switchMap, tap } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import {
  createItemEffect,
  deleteItemEffect,
  loadListEffect,
  updateItemEffect
} from '../../shared/crud/effects';
import { createItem, deleteItem, loadList, updateItem } from './person.actions';
import { PersonRepository } from './person.repository';
import { PersonService } from './person.service';

@Injectable({ providedIn: 'root' })
export class PersonEffects {
  constructor(
    private repository: PersonRepository,
    private service: PersonService,
    private toast: HotToastService
  ) {}

  loadEntities$ = loadListEffect<Person>({
    action: loadList,
    repository: this.repository,
    serviceAction: () => this.service.findAll(),
    toast: this.toast,
  });

  createEntity$ = createItemEffect<Person>({
    action: createItem,
    repository: this.repository,
    serviceAction: (entity) => this.service.create(entity),
    toast: this.toast,
  });

  updateEntity$ = updateItemEffect<Person>({
    action: updateItem,
    repository: this.repository,
    serviceAction: (id, changes) => this.service.update(id, changes),
    toast: this.toast,
  });

  deleteEntity$ = deleteItemEffect<Person>({
    action: deleteItem,
    repository: this.repository,
    serviceAction: (id) => this.service.delete(id),
    toast: this.toast,
  });

  loadEntityById$ = (id: Person['id']) => {
    let toaster: CreateHotToastRef<unknown>;
    return of(id).pipe(
      switchMap((id) => {
        this.repository.updateStatus('item', 'pending');
        environment?.production ||
          (toaster = this.toast.loading(`Загрузка лица`));
        return this.service.findOne(id).pipe(
          tap((entity) => {
            if (!environment?.production) {
              this.toast.success(`Лицо загружено`);
            }
            if (entity) {
              this.repository.updateEntity(entity.id, entity);
            }
          }),
          finalize(() => {
            toaster?.close();
          })
        );
      })
    );
  };
}
